<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      class="custom-drawer"
      width="18.75rem"
      color="gray2"
      height="100%"
      dark
      app
    >
      <div class="d-flex align-center px-4 py-2">
        <v-menu
          content-class="mt-2"
          min-width="12.5rem"
          :close-on-content-click="false"
          offset-y
        >
          <template v-slot:activator="{ on, attrs }">
            <v-badge
              bordered
              offset-x="30"
              offset-y="8"
              :color="_currentStatus"
              bottom
              dot
            >
              <v-avatar
                v-bind="attrs"
                v-on="on"
                class="mr-6"
                size="2.5rem"
                color="gray4"
                rounded
              >
                <v-img v-if="user.photo" :src="user.photo" />
                <v-icon v-else>mdi-account-outline</v-icon>
              </v-avatar>
            </v-badge>
          </template>

          <v-list class="pt-0">
            <v-list-item>
              <v-list-item-title>Definir status</v-list-item-title>
            </v-list-item>

            <v-divider />

            <v-list-item
              v-for="(item, i) in status"
              v-show="!item.hide"
              :key="i"
              :class="{ 'primary--text': user?.status === item.value }"
              :disabled="user.status === 'busy'"
              dense
              @click="changeStatus(item.value)"
            >
              <v-list-item-icon class="mr-2">
                <v-icon :color="item.color" x-small>mdi-circle</v-icon>
              </v-list-item-icon>

              <v-list-item-title>{{ item.label }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>

        <v-spacer />

        <v-btn class="custom-btn mr-2" small icon>
          <v-icon small @click="notificationBell">mdi-bell</v-icon>
        </v-btn>

        <v-menu
          content-class="mt-2"
          min-width="12.5rem"
          :close-on-content-click="false"
          offset-y
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" class="custom-btn" small icon>
              <v-icon small>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>

          <v-list>
            <v-list-item @click="handleDialog()">
              <v-list-item-icon class="mr-2">
                <v-icon small>mdi-account</v-icon>
              </v-list-item-icon>

              <v-list-item-title>Meu Perfil</v-list-item-title>
            </v-list-item>
            <v-list-item @click="signOut()">
              <v-list-item-icon class="mr-2">
                <v-icon small>mdi-logout</v-icon>
              </v-list-item-icon>

              <v-list-item-title>Sair</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>

      <section class="d-flex flex-column pb-4">
        <v-divider class="gray1" />

        <template v-for="(item, i) in _routes">
          <div :key="i">
            <template v-if="item.section">
              <div v-if="item.permission">
                <v-divider class="mb-4 gray1" />

                <div
                  class="white--text text-subtitle-1 font-weight-bold ml-4 mb-4"
                >
                  {{ item.title }}
                </div>

                <div
                  v-for="(subitem, n) in item.routes"
                  :class="{ 'disabled-item': subitem.disabled }"
                  :key="`${i}-sub-${n}`"
                >
                  <div v-if="subitem.expandMode && subitem.permission">
                    <v-list-item
                      class="px-4"
                      :disabled="subitem.disabled"
                      @click="toggleExpand(subitem)"
                    >
                      <v-list-item-avatar
                        v-if="subitem.icon || subitem.svg"
                        rounded
                      >
                        <v-icon v-if="subitem.icon">
                          {{ subitem.icon }}
                        </v-icon>

                        <div v-else-if="subitem.svg" v-html="subitem.svg"></div>
                      </v-list-item-avatar>

                      <v-list-item-title class="gray6--text">
                        {{ subitem.label }}
                      </v-list-item-title>

                      <v-spacer />

                      <v-icon
                        small
                        :class="['chevron', { rotated: isExpanded(subitem) }]"
                      >
                        mdi-chevron-down
                      </v-icon>
                    </v-list-item>

                    <v-expand-transition>
                      <div
                        v-show="isExpanded(subitem)"
                        class="pl-10 pr-4 pb-2 pt-1"
                      >
                        <div
                          v-for="(child, c) in subitem.routes"
                          :key="`${i}-sub-${n}-child-${c}`"
                        >
                          <router-link
                            v-show="child.permission"
                            v-slot="{ href, navigate, isActive }"
                            :to="child?.path || ''"
                            custom
                          >
                            <v-list-item
                              class="px-4"
                              :class="isActive ? 'gray3' : 'transparent'"
                              :href="href"
                              :disabled="child.disabled"
                              @click="navigate"
                            >
                              <v-list-item-avatar
                                v-if="child.icon || child.svg"
                                rounded
                              >
                                <v-icon v-if="child.icon">
                                  {{ child.icon }}
                                </v-icon>

                                <div
                                  v-else-if="child.svg"
                                  v-html="child.svg"
                                ></div>
                              </v-list-item-avatar>

                              <v-list-item-title class="gray6--text">
                                {{ child.label }}
                              </v-list-item-title>
                            </v-list-item>
                          </router-link>
                        </div>
                      </div>
                    </v-expand-transition>
                  </div>

                  <div v-else>
                    <router-link
                      v-show="subitem.permission"
                      v-slot="{ href, navigate, isActive }"
                      :to="subitem?.path || ''"
                      :exact="subitem.exactAtive"
                      custom
                    >
                      <v-list-item
                        class="px-4"
                        :class="isActive ? 'gray3' : 'transparent'"
                        :href="href"
                        :disabled="subitem.disabled"
                        @click="navigate"
                      >
                        <v-list-item-avatar
                          v-if="subitem.icon || subitem.svg"
                          rounded
                        >
                          <v-icon v-if="subitem.icon">
                            {{ subitem.icon }}
                          </v-icon>

                          <div
                            v-else-if="subitem.svg"
                            v-html="subitem.svg"
                          ></div>
                        </v-list-item-avatar>

                        <v-list-item-title class="gray6--text">
                          {{ subitem.label }}
                        </v-list-item-title>
                      </v-list-item>
                    </router-link>
                  </div>
                </div>
              </div>
            </template>

            <div v-else :class="{ 'disabled-item': item.disabled }">
              <div v-if="item.expandMode && item.permission">
                <v-list-item
                  class="px-4"
                  :class="isExpanded(item) ? 'gray3' : 'transparent'"
                  :disabled="item.disabled"
                  @click="toggleExpand(item)"
                >
                  <v-list-item-avatar v-if="item.icon || item.svg" rounded>
                    <v-icon v-if="item.icon">
                      {{ item.icon }}
                    </v-icon>

                    <div v-else-if="item.svg" v-html="item.svg"></div>
                  </v-list-item-avatar>

                  <v-list-item-title class="gray6--text">
                    {{ item.label }}
                  </v-list-item-title>

                  <v-spacer />

                  <v-icon
                    small
                    :class="['chevron', { rotated: isExpanded(item) }]"
                  >
                    mdi-chevron-down
                  </v-icon>
                </v-list-item>

                <v-expand-transition>
                  <div v-show="isExpanded(item)" class="pl-10 pr-4 pb-2 pt-1">
                    <div
                      v-for="(subitem, n) in item.routes"
                      :key="`item-${i}-child-${n}`"
                      :class="{ 'disabled-item': subitem.disabled }"
                    >
                      <router-link
                        v-show="subitem.permission"
                        v-slot="{ href, navigate, isActive }"
                        :to="subitem?.path || ''"
                        custom
                      >
                        <v-list-item
                          class="px-4"
                          :class="isActive ? 'gray3' : 'transparent'"
                          :href="href"
                          :disabled="subitem.disabled"
                          @click="navigate"
                        >
                          <v-list-item-avatar
                            v-if="subitem.icon || subitem.svg"
                            rounded
                          >
                            <v-icon v-if="subitem.icon">
                              {{ subitem.icon }}
                            </v-icon>

                            <div
                              v-else-if="subitem.svg"
                              v-html="subitem.svg"
                            ></div>
                          </v-list-item-avatar>

                          <v-list-item-title class="gray6--text">
                            {{ subitem.label }}
                          </v-list-item-title>
                        </v-list-item>
                      </router-link>
                    </div>
                  </div>
                </v-expand-transition>
              </div>

              <div v-else>
                <router-link
                  v-show="item.permission"
                  v-slot="{ href, navigate, isActive }"
                  :to="item?.path || ''"
                  custom
                >
                  <v-list-item
                    class="px-4"
                    :class="isActive ? 'gray3' : 'transparent'"
                    :href="href"
                    :disabled="item.disabled"
                    @click="navigate"
                  >
                    <v-list-item-avatar v-if="item.icon || item.svg" rounded>
                      <v-icon v-if="item.icon">
                        {{ item.icon }}
                      </v-icon>

                      <div v-else-if="item.svg" v-html="item.svg"></div>
                    </v-list-item-avatar>

                    <v-list-item-title class="gray6--text">
                      {{ item.label }}
                    </v-list-item-title>
                  </v-list-item>
                </router-link>
              </div>
            </div>
          </div>
        </template>
      </section>

      <ProfileDialog
        ref="profileDialog"
        :loading="loading.user"
        @update="handleUpdateUser"
      />
    </v-navigation-drawer>

    <v-dialog v-model="unityDialog" max-width="25rem" persistent>
      <v-card class="pa-6 rounded-lg">
        <div class="d-flex align-center mb-4">
          <div class="text-body-1 font-weight-bold">Selecione uma unidade</div>

          <v-spacer />

          <v-btn icon @click="cancelUnity()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>

        <v-form v-model="valid.unity" ref="formUnity" autocomplete="off">
          <v-select
            v-model="form.unity"
            :items="unities"
            placeholder="Selecione uma unidade"
            item-value="name"
            item-text="name"
            :rules="_rules"
            outlined
          ></v-select>
        </v-form>

        <v-btn
          class="text-none"
          color="primary"
          @click="submitUnity()"
          block
          large
        >
          Confirmar
        </v-btn>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { hasMultiAttendanceExperience } from "@/utils/multiAttendance";
import { getCourts } from "@/services/courts";
import { updateUser } from "@/services/users";
import { handleAlert } from "@/utils";
import ProfileDialog from "./partials/profileDialog/ProfileDialog.vue";

export default {
  name: "NavDrawer",

  components: {
    ProfileDialog,
  },

  data() {
    return {
      drawer: true,
      loading: {
        user: false,
        unities: false,
      },
      status: [
        {
          color: "green",
          value: "online",
          label: "Disponível",
        },
        {
          color: "red",
          value: "busy",
          label: "Ocupado",
          hide: true,
        },
        {
          color: "amber",
          value: "away",
          label: "Ausente",
        },
        {
          color: "grey",
          value: "offline",
          label: "Invisível",
          hide: true,
        },
      ],
      unityDialog: false,
      unities: [],
      valid: {
        unity: false,
      },
      form: {
        unity: "",
      },
      expanded: {
        "expand:Fila de Atendimento": true,
        "expand:Relatórios": true,
      },
    };
  },

  computed: {
    ...mapState(["user", "linkedAccess", "attendanceAccess", "audienceAccess"]),
    ...mapGetters(["attendanceRole", "audienceRole", "masterPermission"]),

    _currentStatus() {
      const status = this.user.status || "online";
      const result = this.status.find((el) => el.value === status);
      return result ? result.color : "green";
    },

    _routes() {
      return [
        {
          label: "Usuários",
          path: "/users",
          icon: "mdi-account-multiple-outline",
          permission: this.$can("people"),
          disabled:
            !this.linkedAccess &&
            !(
              (this._isAdmin || this._isModerator) // admin e moderator podem acessar livremente
            ),
        },
        {
          label: "Configurações",
          path: "/settings",
          icon: "mdi-cog-outline",
          permission: this.$can("permission-groups"),
          disabled: !this.linkedAccess, // regra default
        },
        {
          section: true,
          title: "Módulo de atendimento",
          permission:
            this.$can("desks") ||
            this.$can("reports") ||
            this.$can("attendances") ||
            this.$can("appointments") ||
            this.$can("appointments.queue"),
          routes: [
            {
              label: "Visão Geral",
              path: "/home",
              icon: "mdi-view-dashboard",
              permission: true,
              disabled: !this.attendanceAccess, // regra default
            },
            {
              label: "Balcões",
              path: "/counters",
              icon: "mdi-view-day-outline",
              permission: this.$can("desks"),
              disabled:
                !this.attendanceAccess &&
                !(
                  this._isAdmin // somente admin pode acessar livremente
                ),
            },
            {
              label: "Agendamentos",
              path: "/schedules",
              icon: "mdi-calendar-clock",
              permission: this.$can("appointments"),
              disabled:
                !this.attendanceAccess &&
                !(
                  this._isAdmin // somente admin pode acessar
                ),
            },
            {
              label: "Fila de Atendimento",
              expandMode: true,
              icon: "mdi-chart-box",
              permission:
                this.$can("attendances.queue") ||
                this.$can("appointments.queue"),
              disabled: !this.attendanceAccess, // regra default
              routes: [
                {
                  label: "Balcões",
                  // Piloto de multiatendimento: quem pode conduzir mais de uma
                  // conversa vai para a tela unificada; os demais seguem na
                  // fila em tabela. Gate temporário — ver ADR-008.
                  path: hasMultiAttendanceExperience()
                    ? "/omnichannel"
                    : "/attendance",
                  permission: this.$can("attendances.queue"),
                  disabled: !this.attendanceAccess, // regra default
                },
                {
                  label: "Gabinetes",
                  path: "/schedules-queue",
                  permission: this.$can("appointments.queue"),
                  disabled: !this.attendanceAccess, // regra default
                },
              ],
            },
            {
              label: "Relatórios",
              expandMode: true,
              icon: "mdi-chart-areaspline",
              permission:
                this.$can("reports.attendances") ||
                this.$can("reports.appointments"),
              disabled: !this.attendanceAccess, // regra default
              routes: [
                {
                  label: "Balcões",
                  path: "/reports",
                  permission: this.$can("reports.attendances"),
                  disabled: !this.attendanceAccess, // regra default
                },
                {
                  label: "Gabinetes",
                  path: "/schedules-reports",
                  permission: this.$can("reports.appointments"),
                  disabled: !this.attendanceAccess, // regra default
                },
              ],
            },
          ],
        },
        {
          section: true,
          title: "Módulo de audiência",
          permission: this.$can("audiences") || this.$can("entities"),
          routes: [
            {
              label: this.$t("entities"),
              path: "/entities",
              icon: "mdi-view-day-outline",
              permission: this.$can("entities"),
              disabled:
                !this.audienceAccess &&
                !(
                  this._isAudienceOperator // somente operator pode acessar livremente
                ),
            },
            {
              label: "Audiências",
              path: "/audiences",
              svg: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-gavel"><path d="m14.5 12.5-8 8a2.119 2.119 0 1 1-3-3l8-8"/><path d="m16 16 6-6"/><path d="m8 8 6-6"/><path d="m9 7 8 8"/><path d="m21 11-8-8"/></svg>`,
              permission: this.$can("audiences"),
              disabled: !this.audienceAccess, // regra default
            },
            {
              label: "Diagnóstico",
              path: "/audiences/diagnostics",
              icon: "mdi-stethoscope",
              // Mesma permissão que a API exige: quem pode reprocessar é quem
              // investiga por que a gravação não apareceu.
              permission: this.$can("audiences.reprocess"),
              disabled: !this.audienceAccess,
            },
          ],
        },
      ];
    },

    _rules() {
      return [(v) => !!v || "Campo obrigatório"];
    },

    _isOperator() {
      return this.attendanceRole === "operator";
    },

    _isModerator() {
      return this.attendanceRole === "moderator";
    },

    _isAdmin() {
      return this.attendanceRole === "admin";
    },

    _isSupervisor() {
      return this.attendanceRole === "supervisor";
    },

    _isAudienceAdmin() {
      return this.audienceRole === "admin";
    },

    _isAudienceOperator() {
      return this.audienceRole === "operator";
    },
  },

  methods: {
    handleDrawer() {
      this.drawer = !this.drawer;
    },

    changeStatus(value) {
      this.$emit("change-status", value);
    },

    signOut() {
      this.$emit("sign-out");
    },

    handleMenuAction(action) {
      if (action === "audience") {
        this.getCourts();
        this.unityDialog = true; // href: "https://audiencias-app-673194685875.us-central1.run.app/escolher-vara",
      }
    },

    submitUnity() {
      if (!this.$refs.formUnity.validate()) return;

      const unity = this.form.unity
        .trim()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");
      const newName = unity
        .toLowerCase()
        .replace(/[^\w\s]/g, "")
        .replace(/\s+/g, "-");

      window.location.href = `https://audiencias-app-673194685875.us-central1.run.app/admin/${newName}`;
    },

    cancelUnity() {
      this.unityDialog = false;
    },

    async getCourts() {
      try {
        this.loading.unities = true;

        const payload = {
          limit: 100,
          offset: 0,
          enableAudience: true,
        };

        const { data } = await getCourts(payload);

        this.unities = data;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading.unities = false;
      }
    },

    handleDialog() {
      this.$refs.profileDialog.open();
    },
    notificationBell() {
      this.$emit("notification-bell");
    },
    async handleUpdateUser(body) {
      this.loading.user = true;

      try {
        const payload = structuredClone(body);
        const userID = payload._id || this.user._id;
        delete payload._id;

        await updateUser(userID, payload);
        this.$root.$emit("load-session");

        this.handleAlert("Perfil atualizado.", "success");
      } catch (error) {
        const message =
          error?.response?.data?.message ||
          error?.message ||
          "Erro ao atualizar perfil";
        console.log(message);
        this.handleAlert(message, "error");
      } finally {
        this.loading.user = false;
      }
    },

    handleAlert,

    getExpandKey(item) {
      return item.path ? `expand:${item.path}` : `expand:${item.label}`;
    },

    isExpanded(item) {
      const key = this.getExpandKey(item);
      return !!this.expanded[key];
    },

    toggleExpand(item) {
      const key = this.getExpandKey(item);
      this.$set(this.expanded, key, !this.expanded[key]);
    },
  },
};
</script>

<style src="./style.scss" lang="scss" scoped />
